import { ActionType, getType, StateType } from 'typesafe-actions'
import { IAnswer } from 'types/IAnswer'
import * as actions from './actions'

export type QuestionActions = ActionType<typeof actions>

const answersReducer = (state: IAnswer[] = [], action: QuestionActions) => {
  switch (action.type) {
    case getType(actions.updateAnswer):
      // make a copy of the old state – @todo performance?
      const newState = [...state]

      // mutate new state – which is probably bad?
      newState[action.payload.questionIndex] = {
        answer: action.payload.answer,
        axis: action.payload.axis
      }
      return newState

    default:
      return state
  }
}

export { answersReducer as answers }
export type QuestionsState = StateType<typeof answersReducer>
